export default __webpack_public_path__ + "static/media/yellow-location-icon.08e1aab0.svg";